import { createSlice } from "@reduxjs/toolkit";
import { getAdminPermissionsAPI } from "../../services/adminManagement";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const getAdminPermissionsSlice = createSlice({
  name: "getAdminPermissions",
  initialState: data,
  reducers: {
    getAdminPermissionsInfo(state) {
      state.isLoading = true;
    },
    getAdminPermissionsInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    getAdminPermissionsInfoFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    getAdminPermissionsInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const getAdminPermissionsHandler = (payload = {}) => async (dispatch) => {
  try {
    dispatch(getAdminPermissionsAction.getAdminPermissionsInfo());
    const response = await getAdminPermissionsAPI(payload);
    dispatch(getAdminPermissionsAction.getAdminPermissionsInfoSuccess(response));
  } catch (e) {
    dispatch(getAdminPermissionsAction.getAdminPermissionsInfoFailure(e));
  }
};

export default getAdminPermissionsSlice.reducer;
export const getAdminPermissionsAction = getAdminPermissionsSlice.actions;
